const baseUrl = "https://api.testtube.io/api";
const clientUrl = "https://app.testtube.io";
const path ="https://api.testtube.io";

// const clientUrl = "http://localhost:3000"
//  const path ="http://localhost:5000";
//  const baseUrl = "http://localhost:5000/api";



module.exports = { baseUrl,clientUrl ,path};
